module.exports = __webpack_public_path__ + "static/media/Star1.637e60a1.mp3";